import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const partnersWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/partners', component: () => import('./pages/PartnersPage.js') },
    { path: '/partners/contracts', component: () => import('./pages/ContractsPage.js') },
    {
      path: '/partners/contracts/$contractId',
      component: () => import('./pages/ContractDetailPage.js'),
    },
    { path: '/partners/titles', component: () => import('./pages/TitlesPage.js') },
    { path: '/partners/$partnerId', component: () => import('./pages/PartnerDetailPage.js') },
  ],
  widgets: { 'partners.expiring': () => import('./ExpiringWidget.js') },
});
